module.exports = __webpack_public_path__ + "img/project.63624b09.svg";